<template>
  <div class="mb-8 green lighten-5 rounded overflow-hidden">
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="mx-8 my-4"
      v-html="renderedContent"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
import DOMPurify from 'dompurify'
import { marked } from 'marked'

export default {
  name: 'InstructionsBox',

  props: {
    text: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      renderedContent: '',
    }
  },

  watch: {
    text: {
      handler (value) {
        this.renderContent(value)
      },

      immediate: true,
    },
  },

  created () {
    marked.setOptions({ breaks: true })
  },

  methods: {
    async renderContent (content) {
      const html = await marked.parse(content)

      this.renderedContent = DOMPurify.
        sanitize(html).
        replaceAll('<p>&nbsp;</p>', '<p></p>').
        trim()
    },
  },
}
</script>
